/**
 * ConnectorLine - Vertical line connecting cards in the chain
 */
export const ConnectorLine = () => {
  return (
    <div className="flex justify-center py-2">
      <div className="bg-chariot-stroke h-8 w-0.5" />
    </div>
  );
};
